import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ip } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class CityMapService {

  constructor(
    private http: HttpClient
  ) { }

  character_url: string = ip + '/character/'
  party_url: string = ip + '/party/'
  private cityMap = new BehaviorSubject<boolean>(false);
  cityMapVisible$ = this.cityMap.asObservable();

  private cityMapCoordinates = new BehaviorSubject<any>(null);
  cityMapCoordinates$ = this.cityMapCoordinates.asObservable();



  setCityMapVisiblity(value) {
    this.cityMap.next(value)
  }

  markCharacterInOutInCity(map_code: string | number, character_id: string | number, city_id: string | number) {
    const payload = {
      character_id: character_id,
      city_id: city_id,
      map_code
    }
    return this.http.put(`${this.character_url}toggle-city/`, payload)
  }

  markCharacterInOutInCityGameMaster(map_code: string | number, game_id: string | number, city_id: string | number) {
    const payload = {
      map_code,
      city_id: city_id,
      game_id
    }
    return this.http.put(`${this.party_url}toggle-party-city/`, payload)
  }

  setCityMapCoordinates(value) {

    this.cityMapCoordinates.next(value)
  }
}
